import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';

import View from './NavigationView';
import { isFirstStep } from '../AdvWorkflow/AdvWorkflowSelector';

const mapStateToProps = (state, ownProps) => ({
  isFirstStep: isFirstStep(state, ownProps),
  nextIterators: ownProps.nextIterators,
});

const NavigationContainer = connect(mapStateToProps)(View);

NavigationContainer.defaultProps = {
  doNotSave: false,
  validator: () => [],
  validationId: null,
};

NavigationContainer.propTypes = {
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  backendKey: createCustomPropType(isNonEmptyString).isRequired,
  validationId: PropTypes.string,
  validator: PropTypes.func,
};

export default NavigationContainer;
